import { createSlice } from '@reduxjs/toolkit';

export interface NavigationState {
  showNavItems: boolean;
}

const initialState: NavigationState = {
  showNavItems: true
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    hideNavItems(state) {
      state.showNavItems = false;
    },
    showNavItems(state) {
      state.showNavItems = true;
    },
    clearNavigationDetails: (state) => {
      state.showNavItems = false; // Reset user details
    }
  }
});

export const { hideNavItems, showNavItems, clearNavigationDetails } =
  navigationSlice.actions;
export default navigationSlice.reducer;
